/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseDouble } from '../models/api-response-double';
import { ApiResponseListCompany } from '../models/api-response-list-company';
import { ApiResponseListPhoneCompany } from '../models/api-response-list-phone-company';
import { ApiResponseListPricingAnalyticsExport } from '../models/api-response-list-pricing-analytics-export';
import { ApiResponsePagedResultPricingAnalyticsParams } from '../models/api-response-paged-result-pricing-analytics-params';
import { exportPricingAnalytics } from '../fn/meta-pricing-analytics-api/export-pricing-analytics';
import { ExportPricingAnalytics$Params } from '../fn/meta-pricing-analytics-api/export-pricing-analytics';
import { getAllCompanies } from '../fn/meta-pricing-analytics-api/get-all-companies';
import { GetAllCompanies$Params } from '../fn/meta-pricing-analytics-api/get-all-companies';
import { getCompanyNumbers } from '../fn/meta-pricing-analytics-api/get-company-numbers';
import { GetCompanyNumbers$Params } from '../fn/meta-pricing-analytics-api/get-company-numbers';
import { getPricingAnalytics } from '../fn/meta-pricing-analytics-api/get-pricing-analytics';
import { GetPricingAnalytics$Params } from '../fn/meta-pricing-analytics-api/get-pricing-analytics';
import { getTotalCost } from '../fn/meta-pricing-analytics-api/get-total-cost';
import { GetTotalCost$Params } from '../fn/meta-pricing-analytics-api/get-total-cost';

@Injectable({ providedIn: 'root' })
export class MetaPricingAnalyticsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPricingAnalytics()` */
  static readonly GetPricingAnalyticsPath = '/v1/api/ui/meta-pricing-analytics';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPricingAnalytics()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPricingAnalytics$Response(params: GetPricingAnalytics$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultPricingAnalyticsParams>> {
    return getPricingAnalytics(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPricingAnalytics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPricingAnalytics(params: GetPricingAnalytics$Params, context?: HttpContext): Observable<ApiResponsePagedResultPricingAnalyticsParams> {
    return this.getPricingAnalytics$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultPricingAnalyticsParams>): ApiResponsePagedResultPricingAnalyticsParams => r.body)
    );
  }

  /** Path part for operation `exportPricingAnalytics()` */
  static readonly ExportPricingAnalyticsPath = '/v1/api/ui/meta-pricing-analytics';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportPricingAnalytics()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportPricingAnalytics$Response(params: ExportPricingAnalytics$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListPricingAnalyticsExport>> {
    return exportPricingAnalytics(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportPricingAnalytics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportPricingAnalytics(params: ExportPricingAnalytics$Params, context?: HttpContext): Observable<ApiResponseListPricingAnalyticsExport> {
    return this.exportPricingAnalytics$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListPricingAnalyticsExport>): ApiResponseListPricingAnalyticsExport => r.body)
    );
  }

  /** Path part for operation `getCompanyNumbers()` */
  static readonly GetCompanyNumbersPath = '/v1/api/ui/meta-pricing-analytics/numbers/{companyId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyNumbers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyNumbers$Response(params: GetCompanyNumbers$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListPhoneCompany>> {
    return getCompanyNumbers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyNumbers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyNumbers(params: GetCompanyNumbers$Params, context?: HttpContext): Observable<ApiResponseListPhoneCompany> {
    return this.getCompanyNumbers$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListPhoneCompany>): ApiResponseListPhoneCompany => r.body)
    );
  }

  /** Path part for operation `getTotalCost()` */
  static readonly GetTotalCostPath = '/v1/api/ui/meta-pricing-analytics/getTotalCost';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTotalCost()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalCost$Response(params: GetTotalCost$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDouble>> {
    return getTotalCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTotalCost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalCost(params: GetTotalCost$Params, context?: HttpContext): Observable<ApiResponseDouble> {
    return this.getTotalCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseDouble>): ApiResponseDouble => r.body)
    );
  }

  /** Path part for operation `getAllCompanies()` */
  static readonly GetAllCompaniesPath = '/v1/api/ui/meta-pricing-analytics/companies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllCompanies()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllCompanies$Response(params: GetAllCompanies$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListCompany>> {
    return getAllCompanies(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllCompanies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllCompanies(params: GetAllCompanies$Params, context?: HttpContext): Observable<ApiResponseListCompany> {
    return this.getAllCompanies$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListCompany>): ApiResponseListCompany => r.body)
    );
  }

}
